import React, { useState, useEffect } from 'react';
import style from './index.module.scss';
interface Props {
  marks: number[];
  value: number;
  animation?: boolean;
  currency: string;
  showCurrency?: boolean;
}

const marksOffsetLeft = [10, 40, 70, 100];

export function getCurrentValuePos(target: number, arr: number[]) {
  if (target < arr[0]) {
    return -1;
  }
  const len = arr.length;
  if (target >= arr[len - 1]) {
    return arr.length;
  }
  let position = 0;
  for (let i = 0; i < len; i++) {
    if (target >= arr[i] && target < arr[i + 1]) {
      position = i;
      break;
    }
  }
  return position;
}

function getPercent(target: number, position: number, arr: number[]) {
  if (target === 0) return 0;
  const len = arr.length;
  if (position >= len - 1) return 100;

  let prev: number;
  let next: number;
  let siblingsDistance: number;
  let prevPercent: number;

  if (position < 0) {
    prev = 0;
    next = arr[0];
    siblingsDistance = marksOffsetLeft[0];
    prevPercent = 0;
  } else {
    prev = arr[position];
    next = arr[position + 1];
    if (position === arr.length - 3) {
      siblingsDistance = marksOffsetLeft[2] - marksOffsetLeft[1];
      prevPercent = marksOffsetLeft[1];
    } else if (position === arr.length - 2) {
      siblingsDistance = marksOffsetLeft[3] - marksOffsetLeft[2];
      prevPercent = marksOffsetLeft[2];
    } else {
      siblingsDistance = marksOffsetLeft[1] - marksOffsetLeft[0];
      prevPercent = marksOffsetLeft[0];
    }
  }

  return ((target - prev) / (next - prev)) * siblingsDistance + prevPercent;
}

function getCurrentMarks(position: number, arr: number[]) {
  const len = arr.length;
  let markWithoutEnds: number[] = [];
  if (position <= 0) {
    markWithoutEnds = arr.slice(0, 3);
  } else if (position >= len - 4) {
    markWithoutEnds = arr.slice(len - 4, len - 1);
  } else {
    markWithoutEnds = arr.slice(position, position + 3);
  }
  return [...markWithoutEnds, arr[len - 1]];
}
let timer: any;
function Progress(props: Props) {
  const { value, marks, animation = true, currency, showCurrency = true } = props;

  const [currentMarks, setCurrentMarks] = useState<number[]>([]);
  const [currentPercent, setCurrentPercent] = useState(0);

  function formatCount(count: number) {
    if (!count) {
      return 0;
    }
    if (currency === 'Rp') {
      if (count >= 1000000) {
        return `${(count / 1000000).toLocaleString()}jt`;
      }
      if (count >= 1000) {
        return `${(count / 1000).toLocaleString()}rb`;
      }
    }
    return count.toLocaleString();
  }
  useEffect(() => {
    const floatMarks = marks.map(Number);
    const target = Number(value);
    const valuePosition = getCurrentValuePos(target, floatMarks);
    const currentMarks = getCurrentMarks(valuePosition, floatMarks);
    const currentPercent = getPercent(target, valuePosition, floatMarks);
    timer = setTimeout(() => {
      setCurrentPercent(currentPercent);
    }, 1000);
    setCurrentMarks(currentMarks);
    return () => {
      clearTimeout(timer);
    };
  }, [marks, value]);

  return (
    <div className={style.progress}>
      <div className={style.slot}>
        <div
          className={`${style.bar} ${animation ? style.barAnimate : ''}`}
          style={{
            width: `${currentPercent}%`,
          }}
        ></div>
        {currentMarks.map((item, index) => {
          return (
            <div
              className={`${style.mark} ${style['mark' + index]} ${
                index === currentMarks.length - 1 ? style.lastMark : ''
              }`}
              key={index}
              style={{ left: `${marksOffsetLeft[index]}%` }}
            >
              <div className={style.markInner}>{`${showCurrency ? currency : ''} ${formatCount(item)}`}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Progress;
